import { EventEmitter } from '@src/common/EventEmitter';

export const AuthenticationStorageEvents = {
  SetAccessToken: 'authentication.setAccessToken',
  RemoveAccessToken: 'authentication.removeAccessToken',
};

export const AuthenticationStorage = {
  getAccessToken: (): string | null => localStorage.getItem('accessToken'),

  setAccessToken: (accessToken: string) => {
    localStorage.setItem('accessToken', accessToken);
    EventEmitter.emit(AuthenticationStorageEvents.SetAccessToken, {
      accessToken,
    });
  },

  removeAccessToken: () => {
    localStorage.removeItem('accessToken');
    EventEmitter.emit(AuthenticationStorageEvents.RemoveAccessToken);
  },
};
